<h2 mat-dialog-title>
    Add Service Address Wizard
</h2>

<mat-dialog-content fxLayout="column" [formGroup]="formGroup">
    <div fxFlex fxLayout="row">
        <lgd-text controlName="siteAddress" label="Site Address">
        </lgd-text>

        <button mat-button (click)="lookupSiteAddress()" matTooltip="Search Site Addresses" telemetry="Search-SiteAddress-ServiceAddressWizard-UtilityBilling" aria-label="search">
            <mat-icon>search</mat-icon>
        </button>
    </div>

    <div *ngIf="showRequiredError()" class="error">
        Site Address is required
    </div>

    <lgd-typeahead fxFlex controlName="readGroup" label="Read Group" (searchTextChanged)="lookupReadGroups($event)" [options]="readGroupsObservable" telemetry="Edit-ReadGroup-ServiceAddressWizard-UtilityBilling">
    </lgd-typeahead>

    <lgd-text fxFlex controlName="serviceAddressNumber" label="Service Address Number">
    </lgd-text>

    <busy-indicator *ngIf="isProcessing" page="true"></busy-indicator>

</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-button mat-dialog-close telemetry="Submission-Cancel-ServiceAddressWizard-UtilityBilling">
        Cancel
    </button>

    <button mat-button [disabled]="formGroup.invalid" (click)="submit()" telemetry="Submission-Done-ServiceAddressWizard-UtilityBilling">
        Done
    </button>
</mat-dialog-actions>